import { AppRemixIcon } from '@/layout/AppComponents';
import ReactDOMServer from 'react-dom/server';
import colors from '../../../../../../../constants/colors';
import Translator from '../../../../../../components/helpers/Translator';

export default function AttatchedFile(props) {
  const { files } = props;

  return (
    <span
      title={
        files?.length > 0
          ? ReactDOMServer.renderToString(
              <Translator
                file="module-correctiveActions"
                name="number.of.files"
                variables={{ files: files?.length }}
              />
            )
          : ReactDOMServer.renderToString(
              <Translator
                file="module-correctiveActions"
                name="no.files"
                variables={{ files: files?.length }}
              />
            )
      }
    >
      <AppRemixIcon
        icon="attachment-2"
        color={files?.length > 0 ? colors.primary : colors.grey300}
        noVariants
      />
    </span>
  );
}
